import { Button, Field, makeStyles } from "@fluentui/react-components";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  root: {
    margin: "10px 0",
    display: "flex",
    flexDirection: "column",
  },
  filePicker: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  filePickerButton: {
    width: "fit-content",
  },
  filePickerInput: {
    display: "none",
  },
  selectedFileName: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  label: {
    fontWeight: "bold",
  },
});

type FileSelectionProps = {
  header: string;
  onFileSelect: (file: File) => void;
  selectedFileName?: string;
};

const FileSelection = ({
  header,
  onFileSelect,
  selectedFileName,
}: FileSelectionProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const filePickerRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0];
    if (selectedFile) {
      onFileSelect(selectedFile);
    }
  };

  return (
    <div className={classes.root}>
      <Field label={header} className={classes.label}>
        <div className={classes.filePicker}>
          <Button
            appearance="secondary"
            className={classes.filePickerButton}
            onClick={() => filePickerRef.current?.click()}
          >
            {t("chooseFile")}
          </Button>
          <span className={classes.selectedFileName}>{selectedFileName}</span>
          <input
            ref={filePickerRef}
            className={classes.filePickerInput}
            type="file"
            onChange={handleFileChange}
          />
        </div>
      </Field>
    </div>
  );
};

export default FileSelection;
